import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export function useUserTier() {
  const { user } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ["user-tier", user?.id],
    enabled: !!user,
    queryFn: async () => {
      const { data: profile, error: profileError } = await supabase
        .from("profiles")
        .select("subscription_tier_id")
        .eq("user_id", user!.id)
        .single();
      if (profileError) throw profileError;

      if (!profile?.subscription_tier_id) return null;

      const { data: tier, error: tierError } = await supabase
        .from("subscription_tiers")
        .select("*")
        .eq("id", profile.subscription_tier_id)
        .single();
      if (tierError) throw tierError;
      return tier;
    },
  });

  return {
    tier: data ?? null,
    tierId: data?.id ?? null,
    tierSlug: data?.slug ?? null,
    tierName: data?.name ?? null,
    isLoading,
    hasTier: !!data,
  };
}
